module.exports = __webpack_public_path__ + "static/fonts/TerpelSans-Medium.ca03a69.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TerpelSans/TerpelSans-Medium.woff2
// module id = xNsP
// module chunks = 6